// extracted by mini-css-extract-plugin
export default {"userManagementContainer":"_user-management-page_userManagementContainer__H2QcO"};